import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useRole from "../../../utils/useRole";
import SelectCompanyLogo from "../admin/Presentation/Components/SelectCompanyLogo";
import MyInput from "../../../components/formComponents/MyInput";
import UploadFileStyleTwo from "../admin/Presentation/Components/UploadFileStyleTwo";
import { Button } from "@chakra-ui/react";
import { getAxiosConfig } from "../../../utils/helpers";

import { designStyle } from "../../../utils/options";
import MySelect from "../../../components/formComponents/MySelect";
import { MAX_COMPANY_NAME_LENGTH } from "../../../utils/constant";
import MyToggle from "../../../components/MyToggle";
import TaggedImageUploader, { toUploadFormData } from "./TaggedImageUploader";

const initialData = {
  companyName: "",
  companyLogo: [],
  floorMap: [],
  address: "",
  designStyle: "",
};
// import { Button } from "@chakra-ui/react";

const ImageUploadAdd = () => {
  const [formData, setFormData] = useState({
    title: "",
    uploads: [], // [{ file, tag }]
    isFavorite: false,
  });
  const [errors, setErrors] = useState({ title: null, projectImages: null });
  const [projectId, setProjectId] = useState(null);
  const navigate = useNavigate();
  const { isSuperAdmin, isAdmin, isUser } = useRole();

  const [formdata, setFormdata] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);

  const [isUploading, setIsUploading] = useState(false);

  const handleUploadsChange = (uploads) => {
    setFormData((prev) => ({ ...prev, uploads }));
    setErrors((prev) => ({ ...prev, projectImages: null }));
  };

  const handleTitleChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      title: event.target.value,
    }));
    setErrors((prev) => ({ ...prev, title: null }));
  };

  const handleSubmitImages = async () => {
    if (formData.title.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        title: "Please enter a project title.",
      }));
      return;
    }

    if (formData.uploads.length === 0) {
      setErrors((prev) => ({
        ...prev,
        projectImages: "Please upload at least one image.",
      }));
      return;
    }
    if (formData.title.trim().length > MAX_COMPANY_NAME_LENGTH) {
      // toast.error(`Project Title should be less than ${MAX_COMPANY_NAME_LENGTH} characters`)
      setErrors((prev) => ({
        ...prev,
        title: `Project Title should be less than ${MAX_COMPANY_NAME_LENGTH} characters`,
      }));
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("isFavorite", formData.isFavorite);
    toUploadFormData(formDataToSend, formData.uploads);
    setIsUploading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("usersdatatoken"),
          },
        },
      );

      if (response.status === 201) {
        toast.success(
          "Images uploaded successfully! Now fill in the company details.",
        );
        setProjectId(response.data._id);
      }
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Something went wrong during image upload.");
    } finally {
      setIsUploading(false);
    }
  };

  const postData = async () => {
    if (isLoading) return;

    if (!projectId) {
      toast.error("Please upload images first.");
      return;
    }

    const { companyLogo, companyName, address, floorMap } = formdata;

    try {
      if (!companyName.trim()) {
        toast.error("Company Name is required");
        return;
      }
      if (companyName.trim().length > MAX_COMPANY_NAME_LENGTH) {
        toast.error(
          `Company Name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`,
        );
        return;
      }

      setIsLoading(true);
      const toastId = toast.loading("Submitting basic info...");

      const FORMDATA = new FormData();
      FORMDATA.append("companyName", companyName);
      FORMDATA.append("address", address);
      FORMDATA.append("companyLogo", companyLogo[0]);
      FORMDATA.append("floorMap", floorMap[0]);
      FORMDATA.append("projectId", projectId);

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/add-base`,
        FORMDATA,
        getAxiosConfig({}, true),
      );

      setFormdata(data.data);

      toast.update(toastId, {
        render: "Basic Info Added Successfully",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      navigate(`/project-showcase/${projectId}/edit/projects`);
    } catch (error) {
      console.error("Error posting basic info:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Error Submitting Basic Info",
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formData.title) {
      setFormdata((prev) => ({
        ...prev,
        companyName: formData.title,
      }));
    }
  }, [formData.title]);
  if (isUser) {
    return <Navigate to={"/unauthorized"} replace />;
  }
  return (
    <Layout>
      {!projectId && (
        <div className="p-3 mx-auto container bg-slate-50">
          <div className="mb-8 flex items-center justify-between ">
            <h1 className="text-2xl mt-3 ">Step 1: Upload Project Images</h1>
            <MyToggle
              checked={formData.isFavorite}
              onChange={(val) =>
                setFormData((prev) => ({
                  ...prev,
                  isFavorite: val,
                }))
              }
            />
          </div>
          <div className="flex flex-col px-4 pt-4 pb-5 rounded-lg bg-white mb-4 border">
            <div>
              <input
                className="py-2 px-3 border w-full rounded-lg outline-primary-500"
                value={formData.title}
                onChange={handleTitleChange}
                placeholder="Enter project title..."
              />
              {errors.title && (
                <p className="text-red-500 text-xs px-2 pt-1">{errors.title}</p>
              )}
            </div>
            <TaggedImageUploader
              uploads={formData.uploads}
              onChange={handleUploadsChange}
            />
            {errors.projectImages && (
              <p className="text-red-500 text-xs px-2 pt-1">
                {errors.projectImages}
              </p>
            )}
          </div>
          <Button
            isLoading={isUploading}
            loadingText="Uploading Images..."
            disabled={isUploading}
            isDisabled={isUploading}
            colorScheme="blue"
            onClick={handleSubmitImages}
          >
            Upload Images
          </Button>
        </div>
      )}

      {projectId && (
        <div className="container mx-auto p-4 ">
          <h2 className="text-xl">Fill The Basic Information</h2>
          <div className="grid grid-cols-2 gap-4 mt-8 ">
            <div>
              <SelectCompanyLogo
                required={false}
                setImage={(image) => {
                  setFormdata((prev) => ({ ...prev, companyLogo: [image] }));
                }}
                image={formdata.companyLogo?.[0]}
              />
            </div>

            <div>
              <UploadFileStyleTwo
                label={"Floor Map"}
                file={formdata.floorMap}
                required={false}
                setFile={(file) => {
                  // console.log(file, "file in floor map");
                  setFormdata((prev) => ({
                    ...prev,
                    floorMap: [...file],
                  }));
                }}
              />
            </div>
            <div>
              <MyInput
                required={true}
                placeholder={"Type here Company Name"}
                label={"Company Name"}
                value={formdata.companyName}
                onChange={(e) =>
                  setFormdata((prev) => ({
                    ...prev,
                    companyName: e.target.value,
                  }))
                }
              />
            </div>
            <div>
              <MyInput
                required={false}
                placeholder={"Type here Company Address"}
                label={"Address"}
                value={formdata.address}
                onChange={(e) =>
                  setFormdata((prev) => ({ ...prev, address: e.target.value }))
                }
              />
            </div>
            {/* <div>
              <MySelect
                required={true}
                placeholder={"Select Design Style"}
                label={"Design Style"}
                value={formdata.designStyle}
                options={designStyle.map((v) => v.name)}
                onChange={(val) =>
                  setFormdata((prev) => ({ ...prev, designStyle: val }))
                }
              />
            </div> */}
          </div>
          <div className="mt-4 flex justify-end ">
            <Button
              isLoading={isLoading}
              loadingText="Submitting..."
              disabled={isLoading}
              isDisabled={isLoading}
              colorScheme="teal"
              onClick={postData}
            >
              Submit
            </Button>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ImageUploadAdd;
